export default __webpack_public_path__ + "static/media/lenevo.38a9e1b9.png";